module.exports = __webpack_public_path__ + "img/logo_bpjstk1.62fc9205.png";